module.exports = __webpack_public_path__ + "img/individual-meter-water-meter-cold-md.ca30cba7.svg";